import React, { lazy, useState } from 'react';
import AddEditParts from './AddEditParts';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);

const TopActions = ({ Styled, i18n, saveParts, callback, viewOnly }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [withCloseIcon, setWithCloseIcon] = useState(true);
  const [backgroundModal, setBackgroundModal] = useState(false);
  const [modalObject, setModalObject] = useState({
    header: '',
    content: () => { },
  });

  const closeModal = () => setModalOpen(false);

  if (viewOnly) return null;

  const openAddPartModal = () => {
    setWithCloseIcon(true);
    setBackgroundModal(false);
    setModalObject({
      header: '',
      content: () => (
        <AddEditParts
          closeModal={closeModal}
          callback={callback}
          saveParts={saveParts}
          Styled={Styled}
        />
      ),
    });
    setModalOpen(true);
  };

  return (
    <Styled.Wrapper>
      <FormStyle.default.ButtonsWrapper>
        <Button
          className="buttonStyle"
          label={i18n.t('parts.addPart')}
          onClick={openAddPartModal}
        />
      </FormStyle.default.ButtonsWrapper>
      <Modal
        open={modalOpen}
        setOpen={setModalOpen}
        data={modalObject}
        onCloseModal={closeModal}
        background="black"
        withCloseIcon={withCloseIcon}
        backgroundModal={backgroundModal}
        deletePopup
      />
    </Styled.Wrapper>
  );
};

export default TopActions;